var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWagonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_1",
    height: 7.13074,
    width: 21.39222,
    y: 7.25084,
    x: 1.30389
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_2",
    d: "m15.38162,14.89263l-6.76325,0l-6.76325,0l-1.12721,0l0,1.12721l1.12721,0l0,1.12721c0,0.62222 0.50499,1.12721 1.12721,1.12721s1.12721,-0.50499 1.12721,-1.12721l2.25442,0c0,0.62222 0.50499,1.12721 1.12721,1.12721s1.12721,-0.50499 1.12721,-1.12721l0,-1.12721l6.76325,0l0,1.12721c0,0.62222 0.50499,1.12721 1.12721,1.12721s1.12721,-0.50499 1.12721,-1.12721l2.25442,0c0,0.62222 0.50499,1.12721 1.12721,1.12721s1.12721,-0.50499 1.12721,-1.12721l0,-1.12721l1.12721,0l0,-1.12721l-1.12721,0l-6.76325,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWagonIcon);
export default __webpack_public_path__ + "static/media/wagon_icon.279229c7bf77563ef9b76d8c39ad7726.svg";
export { ForwardRef as ReactComponent };